import React from 'react';
import type { BlockedByStudents } from './cms_user_fields';

// Inline refusal with a deep link to the Advisors tab, where the students get reassigned.
export default function HasActiveStudentsNotice({ blocked }: { blocked: BlockedByStudents }) {
  return (
    <div role="alert" className="text-sm mt-2" style={{ color: 'var(--state-error)' }}>
      <span>{blocked.message}</span>{' '}
      <a href={blocked.link} style={{ textDecoration: 'underline' }}>
        Open Advisors tab
      </a>
    </div>
  );
}
